import { render, staticRenderFns } from "./account_manage.vue?vue&type=template&id=3b286319&scoped=true&"
import script from "./account_manage.vue?vue&type=script&lang=js&"
export * from "./account_manage.vue?vue&type=script&lang=js&"
import style0 from "./account_manage.vue?vue&type=style&index=0&id=3b286319&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b286319",
  null
  
)

export default component.exports